import { render, staticRenderFns } from "./smartPavilionDetails.vue?vue&type=template&id=4f5c4662&scoped=true"
import script from "./smartPavilionDetails.vue?vue&type=script&lang=js"
export * from "./smartPavilionDetails.vue?vue&type=script&lang=js"
import style0 from "./smartPavilionDetails.vue?vue&type=style&index=0&id=4f5c4662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c4662",
  null
  
)

export default component.exports